import { CommandDescriptor, CommandContext } from "./types";
import { CommandRegistry } from "./CommandRegistry";

export class CommandBus {
  private registry: CommandRegistry;

  constructor(registry: CommandRegistry) {
    this.registry = registry;
  }

  register(command: CommandDescriptor) {
    return this.registry.register(command);
  }

  unregister(commandId: string) {
    this.registry.unregister(commandId);
  }

  list() {
    return this.registry.list();
  }

  async execute(
    commandId: string,
    payload?: unknown,
    context: CommandContext = {},
  ): Promise<boolean> {
    const command = this.registry.get(commandId);
    if (!command) return false;

    if (command.when && !command.when()) return false;

    await command.run(payload, context);
    return true;
  }
}

export const desktopCommandRegistry = new CommandRegistry();
export const commandBus = new CommandBus(desktopCommandRegistry);
